import { makeStyles } from "@material-ui/core/styles";
import { TheCycleverseTheme } from "src/theme";
import React from "react";
import { CalculatorHeadline, CalculatorInputHeadline, CalculatorTopicHeadline } from "../CalculatorTypography";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginTop: "50px",
  },
  divider: {
    width: "100%",
    height: "1px",
    backgroundColor: "#bababa",
  },
  dividerLabel: {
    width: "40px",
    height: "40px",
    borderRadius: "20px",
    marginTop: "-20.5px",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
  },
  input: {
    border: "none",
    height: "50px",
    borderRadius: "10px",
    marginRight: "10px",
    width: "20vw",
  },
  inputUnit: {
    fontWeight: "bold",
    fontSize: "16px",
    marginLeft: "10px",
    marginRight: "10px",
    width: "95px",
    textAlign: "left",
  },
  dividerContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    alignContent: "center",
    justifyItems: "center",
    justifyContent: "center",
  },
}));

export const InputHeader = ({ inputNumber, children, inputTitle }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.dividerContainer}>
        <div className={classes.divider}></div>
        <img
          className={classes.dividerLabel}
          src={`/images/calculators/number_icons/orange_${inputNumber}.svg`}
          alt="number"
        />
      </div>
      <CalculatorInputHeadline>{inputTitle}</CalculatorInputHeadline>
      {children}
    </div>
  );
};
